// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.module {
  width: 100%;
  height: 100%;
}

.main {
  padding: 15px 0px 0px 0px;
  height: 100%;
  flex-direction: column;
  width: 100%;
  min-width: 289px;
  min-height: 640px;
  overflow: hidden;
}

.search {
  width: 100%;
  margin-bottom: 15px;
  margin-left: 6px;
  margin-right: 6px;
}

.modules {
  overflow-y: auto;
  padding-right: 6px;
  padding-left: 6px;
}

@media (max-width: 1199px) {
  .modules .pl-2 {
    padding-left: 0 !important;
  }
  .modules .pr-2 {
    padding-right: 0 !important;
  }
}
.module-height {
  margin-bottom: 0px !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
